import { render, staticRenderFns } from "./modal-add-brand.vue?vue&type=template&id=cd7c981e&scoped=true"
import script from "./modal-add-brand.vue?vue&type=script&lang=js"
export * from "./modal-add-brand.vue?vue&type=script&lang=js"
import style0 from "./modal-add-brand.vue?vue&type=style&index=0&id=cd7c981e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7c981e",
  null
  
)

export default component.exports